import * as React from "react";
import styled from "styled-components";

import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import LoadingIcon from "@material-ui/icons/Timelapse";

import { DetailContainer } from "../common/detail-container";
import { DetailSaveProps } from "./detail-save-props";

import { edit as editRelease } from "../../../../sdk/release";

export const ReleaseSaveActions: React.FC<DetailSaveProps> = (props) => {
  const [loading, setLoading] = React.useState(false);

  const handleSave = async () => {
    setLoading(true);
    await editRelease(
      props.release.id,
      props.release,
      props.tracks,
      props.collaborators
    );
    setLoading(false);
    props.onSave(true);
  };

  return (
    <DetailContainer>
      <ActionContainer>
        <Button
          variant="contained"
          color="secondary"
          endIcon={<CancelIcon />}
          onClick={() => props.onSave(false)}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          endIcon={loading ? <LoadingIcon /> : <SaveIcon />}
          onClick={handleSave}
        >
          Save
        </Button>
      </ActionContainer>
    </DetailContainer>
  );
};

const ActionContainer = styled.div`
  float: right;
  width: 100%;
  height: 100%;
  max-width: 420px;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-end;
  & > button {
    margin-left: 0.25rem;
  }
`;
